
const Container = ({ children, className = "" }) => {
  return (
      <div className={`w-full max-w-8xl mx-auto min-h-screen bg-white py-4 px-2 sm:px-6 lg:px-8 ${className}`}>
        {children}
    </div>
  )
}

export default Container;
